<template>
  <main>
    <hero :heading="entry.title" :images="entry.heroImages" position="bottom" />
    <div class="c-section" v-if="entry.body">
      <div class="o-wrapper o-wrapper--small">
        <div class="c-rte o-box-off" v-html="entry.body"></div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/Hero.vue'

export default {
  name: 'Privacy',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero
  },
  data () {
    return {
      title: '',
      entry: null
    }
  },
  mounted () {
    this.getEntry()
  },
  methods: {
    getEntry () {
      axios
        .get('/api/privacy.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Privacy.vue